import { z } from "zod";

import { patientsApiContract } from "@libs/api/patients";
import { HTTPStatusCode } from "@libs/api/types";

export const signedConsentDocumentsSchema =
  patientsApiContract.consentDocuments.getSignedConsentDocuments.responses[
    HTTPStatusCode.OK
  ];

export type SignedConsentDocumentType = z.infer<
  typeof signedConsentDocumentsSchema
>[number];

export const getRepresentativeName = (document: SignedConsentDocumentType) => {
  if (document.representativeFirstName && document.representativeLastName) {
    return {
      firstName: document.representativeFirstName,
      middleName: document.representativeMiddleName,
      lastName: document.representativeLastName,
    };
  }

  return null;
};
